import React, { useMemo } from "react";
import { SOURCE_TYPE_SHOP_PAGE_RECENTLY_VIEWED } from "@catchoftheday/analytics";
import { Box } from "@catchoftheday/cg-components";
import { EnhancedHeader, Footer } from "@catchoftheday/header";
import { SHOP_PAGE_RECOMMENDER_BEST_SELLER_PRODUCTS_CATEGORY, SHOP_PAGE_RECOMMENDER_TRENDING_PRODUCTS_CATEGORY, SHOP_PRODUCTS_RECOMMENDER_MIN_COUNT, ShopBannerStripContainer, ShopExclusiveDealsContainer, ShopFeaturedProductsContainer, ShopHeader, ShopHeroBannerContainer, ShopRecommendersContainer } from "@catchoftheday/onepass";
import { BestSellerProducts, RecentlyViewedProducts, TrendingProducts } from "@catchoftheday/personalisation";
import { Page } from "@onepass-app/components/Page";
import { ShopMemberBenefits } from "@onepass-app/components/ShopMemberBenefits";
import { ShopMigrationNudge } from "@onepass-app/components/ShopMigrationNudge";
import { ShopPageSEO } from "@onepass-app/components/ShopPageSEO";
import { ShopUpcomingDeals } from "@onepass-app/components/ShopUpcomingDeals";
import { productsCarouselFactory } from "@onepass-app/utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ShopPage = function ShopPage(_ref) {
  var host = _ref.host;
  var recentlyViewedProductsComponent = useMemo(function () {
    return ___EmotionJSX(RecentlyViewedProducts, {
      carouselWrapperProps: {
        px: 3,
        mx: "auto"
      },
      sourceType: SOURCE_TYPE_SHOP_PAGE_RECENTLY_VIEWED,
      Wrapper: function Wrapper(_ref2) {
        var children = _ref2.children;
        return ___EmotionJSX(Box, {
          backgroundColor: "white",
          border: 1,
          borderColor: "grey",
          py: 3,
          px: {
            _: 0,
            xs: 3
          }
        }, children);
      }
    });
  }, []);
  var bestSellerProductsNode = useMemo(function () {
    return ___EmotionJSX(BestSellerProducts, {
      minCount: SHOP_PRODUCTS_RECOMMENDER_MIN_COUNT,
      categoryId: SHOP_PAGE_RECOMMENDER_BEST_SELLER_PRODUCTS_CATEGORY
    });
  }, []);
  var trendingProductsNode = useMemo(function () {
    return ___EmotionJSX(TrendingProducts, {
      minCount: SHOP_PRODUCTS_RECOMMENDER_MIN_COUNT,
      category: SHOP_PAGE_RECOMMENDER_TRENDING_PRODUCTS_CATEGORY
    });
  }, []);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ShopPageSEO, {
    host: host
  }), ___EmotionJSX(EnhancedHeader, {
    host: host
  }), ___EmotionJSX(Page, null, ___EmotionJSX(ShopHeader, null), ___EmotionJSX(ShopBannerStripContainer, null), ___EmotionJSX(ShopHeroBannerContainer, {
    host: host
  }), ___EmotionJSX(ShopFeaturedProductsContainer, {
    ProductsCarouselComponent: productsCarouselFactory()
  }), ___EmotionJSX(ShopMigrationNudge, null), ___EmotionJSX(ShopUpcomingDeals, null), ___EmotionJSX(ShopMemberBenefits, null), ___EmotionJSX(ShopRecommendersContainer, {
    bestSellerProductsNode: bestSellerProductsNode,
    trendingProductsNode: trendingProductsNode,
    ProductsCarouselComponent: productsCarouselFactory()
  }), ___EmotionJSX(ShopExclusiveDealsContainer, {
    recentlyViewedProductsComponent: recentlyViewedProductsComponent
  })), ___EmotionJSX(Footer, null));
};